import React from "react";
import {
  BannerContainer,
  BannerContent,
  BannerImage,
} from "../../styles/banner";
import { Typography } from "@mui/material";
import contactImage from "../../assets/contactImage.png";

export default function ContactAddress() {
  return (
    <>
      <BannerContainer>
        <BannerImage src={contactImage}></BannerImage>
        <BannerContent>
          <Typography variant="h3">Contact Us</Typography>
          <Typography variant="h4">How can we help you?</Typography>
        </BannerContent>
      </BannerContainer>
    </>
  );
}

